import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CheckmarkIcon, TrashIcon } from "../../../lib/icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const grid = 8;

const getItemStyle = (isDragging, transform, transition) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,
  paddingLeft: "4px",
  paddingRight: "4px",
  paddingTop: "0px",
  paddingBottom: "0px",
  position: "relative",
  zIndex: isDragging ? 1 : "auto",

  // change background colour if dragging
  background: isDragging ? "rgba(62, 171, 203, 0.3)" : "white",
  transform: transform ? `translate3d(${Math.round(transform.x)}px, ${Math.round(transform.y)}px, 0)` : undefined,
  transition,
});

export function CartItem({ id, item, deleteHandler }) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id });

  return (
    <div
      ref={setNodeRef}
      style={getItemStyle(isDragging, transform, transition)}
      data-testid="ppt-cart-slide-item"
      data-slide-id={id}>
      <div className="slide-item">
        <div className="slide-num">{(item.order + 1).toString()}</div>
        <div className="slide-copy">
          <div
            className="slide-title"
            ref={setActivatorNodeRef}
            {...attributes}
            {...listeners}
            data-testid="ppt-cart-slide-drag-handle">
            {item.name}
          </div>
          {item.status === "pending" ? (
            <div className="slide-status" role="status">
              <span className="slide-status-spinner" />
              Exporting...
            </div>
          ) : item.status === "failed" ? (
            <div className="slide-status slide-status-failed" role="status">
              Export failed
            </div>
          ) : item.status === "complete" ? (
            <div className="slide-status slide-status-complete" role="status">
              <CheckmarkIcon height={"9"} color={"#287A45"} />
              Export complete
            </div>
          ) : null}
        </div>
        <OverlayTrigger key={"removeslide-tip"} placement={"top"} overlay={<Tooltip id={"removeslide-tip"}>Remove Slide</Tooltip>}>
          <div className="slide-delete-icon" data-testid="ppt-cart-slide-delete" onClick={() => deleteHandler(item)}>
            <TrashIcon height={"16"} color={"rgba(88, 89, 91, 1)"} />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
}